import {IdType} from '../../../../util/models/IdType'
import {selectClassificationTree} from '../../../rtkSearchApi'
import {useDatxPathGenerator} from '../../../../util/routing'
import {useSelector} from 'react-redux'
import React, {useEffect, useState} from 'react'
import {BreadCrumbs, BreadcrumbType} from '../../../../genericComponents/breadcrumbs/BreadCrumbs'
import {getPathToClassification} from '../../../../util/classifications/Classification'
import {ROUTES} from '../../../../constants/routing'
import {Box} from '@mui/material'
import SearchFilters from '../../../searchFilter/SearchFilters'
import {useSearchResultControl} from '../../useSearchResultControl'
import {
    SearchResultsComponentForClassificationAndPhraseSearch
} from '../SearchResultsComponent/SearchResultsComponentForClassificationAndPhraseSearch'
import {useFullSearch} from '../../useFullSearch'

export const SearchResultPageForClassificationNode = ({
                                                          classificationId
                                                      }: {
    classificationId: IdType
}) => {

    const fullSearchResult = useFullSearch({
        useFilters: true
    })

    const {searchResult, search, page, isSearchFetching} = fullSearchResult
    const generatePath = useDatxPathGenerator()
    const classificationTree = useSelector(selectClassificationTree)
    const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbType[]>([])

    const getBreadcrumbs = () => {
        if (!classificationId) return
        const classificationPath = getPathToClassification(classificationId, classificationTree)

        setBreadcrumbs(classificationPath.map((classification) => {
            return {
                link: {
                    pathname: generatePath(ROUTES.searchByClassificationNodeDescendants.path, {classificationId: classification.id}),
                    search: 'page=1'
                },
                label: classification?.label,
                id: classification.id
            }
        }))
    }

    const searchResultControl = useSearchResultControl({searchResult, page})

    useEffect(() => {
        getBreadcrumbs()
    }, [classificationId, classificationTree])

    return <Box className="item-list-page">
        {searchResult &&
            <BreadCrumbs breadcrumbList={breadcrumbs} totalResults={searchResult.totalElements}
                         isFetching={isSearchFetching}/>}
        <SearchFilters search={search} resetItemsSelectedList={searchResultControl.resetMultiSelect}/>
        <SearchResultsComponentForClassificationAndPhraseSearch
            // Added key : If one of these attribute changes, the searchResults Component is reredended
            key={`${search.guildId}_${search.phrase}_${search.technicalClassificationNodeId}`}
            fullSearchResult={fullSearchResult}
        />
    </Box>
}